import React from 'react';
import '../CSS/PatientCare.css';
import patientCareHero from '../Images/services/Patient Care/services-patient-care.png';
import patientCareHeroMob from '../Images/Mobile Images/services/Patient Care/service-patient-care-banner-image-moble.png';
import patientCareSectionImg from '../Images/services/Patient Care/patient-care-section-image.png';
import preVisitImgMob from '../Images/Mobile Images/services/Patient Care/pre-visit-patient-access-section-image-mobile.png';
import patientBillingImgMob from '../Images/Mobile Images/services/Patient Care/patient-billing-section-image-mobile.png';
import comprehensiveSupportImgMob from '../Images/Mobile Images/services/Patient Care/comprehensive-support-section-image-mobile.png';
import greenTick from '../Images/green-tick-icon.svg';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

const PatientCare: React.FC = () => {
  return (
    <div className="patient-care-container">
      <div className="patient-care-hero">
        <picture>
          <source media="(max-width: 1100px)" srcSet={patientCareHeroMob} />
          <img src={patientCareHero} alt="Patient Care Hero" className="patient-care-hero-img" />
        </picture>
        <div className="patient-care-hero-content">
          <div className="patient-care-hero-title">Patient Care</div>
          <div className="patient-care-hero-main">Address Nursing Shortages with Confidence</div>
          <div className="patient-care-hero-desc">
            Sustainably recruit and retain high-quality nurses committed to patient care and community impact.
          </div>
        </div>
      </div>
      {/* Recruiting Nurses Section */}
      <div className="recruiting-nurses">
        <div className="recruiting-nurses-title">
          Strengthen Your Pipeline for Recruiting and Retaining Full-Time Registered Nurses
        </div>
        <Link to="/contact-us" className="recruiting-nurses-contact-btn">Contact Us</Link>
        <div className="recruiting-nurses-cards">
          <div className="recruiting-nurses-card">
            <div className="recruiting-nurses-card-title">Choose an Easier Path to Nurse Retention</div>
            <div className="recruiting-nurses-card-desc">Temporary "Travel Nurses" are too costly to the bottom line and unit stability.</div>
          </div>
          <div className="recruiting-nurses-card">
            <div className="recruiting-nurses-card-title">Grow Your Team with Trained Professionals</div>
            <div className="recruiting-nurses-card-desc">Medwell360 nurses receive all credentials and training prior to arriving in the U.S.</div>
          </div>
          <div className="recruiting-nurses-card">
            <div className="recruiting-nurses-card-title">Positively Impact Your Hospital Culture</div>
            <div className="recruiting-nurses-card-desc">International nurses on 3-year assignments will reduce turnover and improve morale.</div>
          </div>
        </div>
      </div>
      {/* AI Services for Patient Care Section */}
      <div className="ai-services-patientcare-section">
        <div className="ai-services-patientcare-section-title">AI Services for Patient Care</div>
        <div className="ai-services-patientcare-section-content">
          <div className="ai-services-patientcare-section-left">
            <div className="ai-services-patientcare-section-subtitle">Pre-visit & Patient Access</div>
            <div className="ai-services-patientcare-section-label">Traditional Process</div>
            <div className="ai-services-patientcare-section-desc">Manual insurance verification and authorization</div>
            <div className="ai-services-patientcare-section-label" style={{ marginTop: 24 }}>AI Enhancement</div>
            <div className="ai-services-patientcare-section-desc">AI agents automate eligibility checks and flag mismatches before scheduling</div>
            <div className="ai-services-patientcare-section-label" style={{ marginTop: 24 }}>Outcomes</div>
            <div className="ai-services-patientcare-section-desc">20-40% reduced claim denials</div>
            <ul className="ai-services-patientcare-section-list">
              <li>Faster registration process</li>
            </ul>
          </div>
          <div className="ai-services-patientcare-section-right">
            <picture>
              <source media="(max-width: 1100px)" srcSet={preVisitImgMob} />
              <img src={require('../Images/services/Patient Care/pre-visit-patient-access-section-image.png')} alt="AI Services for Patient Care Illustration" className="ai-services-patientcare-section-img" />
            </picture>
          </div>
        </div>
      </div>
      {/* Patient Billing & Collections Section */}
      <div className="patient-billing-section">
        <div className="patient-billing-section-right">
          <picture>
            <source media="(max-width: 1100px)" srcSet={patientBillingImgMob} />
            <img src={require('../Images/services/Patient Care/patient-billing-section-image.png')} alt="Patient Billing & Collections Illustration" className="patient-billing-section-img" />
          </picture>
        </div>
        <div className="patient-billing-section-left">
          <div className="patient-billing-section-title">Patient Billing & Collections</div>
          <div className="patient-billing-section-label">Traditional Process</div>
          <div className="patient-billing-section-desc">Static bills sent without personalization</div>
          <div className="patient-billing-section-label" style={{ marginTop: 24 }}>AI Enhancement</div>
          <div className="patient-billing-section-desc">AI tailors bills based on payment behavior; virtual agents handle inquiries</div>
          <div className="patient-billing-section-label" style={{ marginTop: 24 }}>Outcomes</div>
          <ul className="patient-billing-section-list">
            <li>20-40% reduced claim denials</li>
            <li>15-25% increased patient collections</li>
            <li>Improved satisfaction and transparency</li>
          </ul>
        </div>
      </div>
      {/* Recruitment Checklist Section */}
      <div className="recruitment_checklist">
        <div className="recruitment_checklist-right">
          <div className="recruitment_checklist-title">Comprehensive Support from Recruitment to Integration</div>
          <ul className="recruitment_checklist-list">
            <li><img src={greenTick} alt="Green Tick" className="recruitment_checklist-tick" /> We strategically match international nurses to your organization's specific clinical needs</li>
            <li><img src={greenTick} alt="Green Tick" className="recruitment_checklist-tick" /> Our team manages the entire immigration process, including visa acquisition</li>
            <li><img src={greenTick} alt="Green Tick" className="recruitment_checklist-tick" /> We coordinate housing and arrival logistics, ensuring nurses are settled before onboarding begins</li>
            <li><img src={greenTick} alt="Green Tick" className="recruitment_checklist-tick" /> Throughout each assignment, we provide ongoing clinical oversight and support to ensure continuity and success</li>
          </ul>
        </div>
        <div className="recruitment_checklist-left">
          <img src={patientCareSectionImg} alt="Recruitment Process" className="recruitment_checklist-img" />
        </div>
      </div>
      {/* Patient Care Metrics Section */}
      <div className="patient-care-metrics">
        <div className="pcm-title">Benefiting from Medwell360 Nurses</div>
        <div className="pcm-metrics-row">
          <div className="pcm-metric">
            <div className="pcm-metric-value">6 Years</div>
            <div className="pcm-metric-label">Average acute care experience held by each Medwell360 international nurse—ensuring readiness from day one.</div>
          </div>
          <div className="pcm-metric">
            <div className="pcm-metric-value">75%</div>
            <div className="pcm-metric-label">Of our international nurses transition to full-time roles with hospital partners after completing their assignments.</div>
          </div>
          <div className="pcm-metric">
            <div className="pcm-metric-value">15 Years</div>
            <div className="pcm-metric-label">Medwell360 has successfully placed and supported thousands of international nurses across leading U.S. healthcare systems.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientCare; 